<template>
  <ModalDialog
    ref="dialog"
    title="Edit Invoice"
    :submitting="submitting"
    :submitDisabled="submitting"
    submitTitle="Update"
    icon="fa-envelope-open-dollar"
    :scrollable="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-bind:form="dialogForm" v-show="!loading && !loadingError">
      <FormRow label="Due Date">
        <FormDate v-model="invoiceData.dateDue" field="dateDue" placeholder="Due Date" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>


<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'


export default {
  name: 'EditInvoiceDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    invoiceId: Number
  },
  data() {
    return {
      dialogForm: {},
      invoiceData: { },
      loading: false,
      loadingError: '',
      submitting: false
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    
  },
  methods: {
    show(options = {}) {
      // Reset form
      this.responseInfo = { }
      this.dialogForm = { }

      this.requestData()

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      var updateData = {
        dateDue: this.invoiceData.dateDue
      }

      this.submitting = true
      this.$apiService.accountsService.updateInvoice(this.invoiceId, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    },
    requestData() {
      this.invoiceData = {}
      this.loading = true
      this.loadingError = ''

      this.$apiService.accountsService.getInvoice(this.invoiceId)
      .then(response => {
        this.invoiceData = response.data
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    },
  }
}
</script>